module.exports = __webpack_public_path__ + "img/Southwest_Quinoa_Bowl_Tofu.423647e3.jpg";